import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiLinearProgress: Components<Theme>['MuiLinearProgress'] = {
  defaultProps: {
    color: 'purple',
  },
  styleOverrides: {
    root: {
      borderRadius: 'var(--border-radius-small)',
      height: 'var(--spacing-unit-1)',
      width: '100%',
      variants: [
        {
          props: {
            color: 'purple',
          },
          style: {
            backgroundColor: scssVariables.ColorPurple20,
            '& .MuiLinearProgress-bar': {
              backgroundColor: scssVariables.ColorPurple80,
            },
          },
        },
        {
          props: {
            color: 'fog',
          },
          style: {
            backgroundColor: scssVariables.ColorFog20,
            '& .MuiLinearProgress-bar': {
              backgroundColor: scssVariables.ColorFog100,
            },
          },
        },
        {
          props: {
            color: 'blue',
          },
          style: {
            backgroundColor: scssVariables.ColorBlue20,
            '& .MuiLinearProgress-bar': {
              backgroundColor: scssVariables.ColorBlue80,
            },
          },
        },
        {
          props: {
            color: 'coral',
          },
          style: {
            backgroundColor: scssVariables.ColorCoral20,
            '& .MuiLinearProgress-bar': {
              backgroundColor: scssVariables.ColorCoral80,
            },
          },
        },
        {
          props: {
            color: 'maroon',
          },
          style: {
            backgroundColor: scssVariables.ColorMaroon20,
            '& .MuiLinearProgress-bar': {
              backgroundColor: scssVariables.ColorMaroon80,
            },
          },
        },
      ],
    },
    bar: {
      borderRadius: 'var(--border-radius-small)',
    },
  },
};
